import { IBus } from "@sg-widgets/platform-api/lib/bus";
import { WidgetConfiguration } from "@sgwt-widget/core";
import * as URI from "urijs";
import { CProfitWidgetConfiguration } from "../cprofitWidgetConfiguration";
import { IHeaders } from "../utils/types";
import { handleBlob } from "./export-helper";
import { GenericResponse } from "./generic-types";

export async function MakeAuditTraceApiCall(
  headers: IHeaders,
  url: string,
  fileName: string | null,
  configuration: WidgetConfiguration,
  correlationId: string
) {
  return getSgConnectTokenFromBus(configuration.bus).then(async token => {
    const response = new GenericResponse();
    const cprConfig = new CProfitWidgetConfiguration(configuration);
    const fullUri = URI(url).absoluteTo(cprConfig.auditTraceApiUrl);

    // tslint:disable-next-line:ban
    const apiResponse = await fetch(fullUri.valueOf(), {
      headers: new Headers({
        ...headers,
        Authorization: token as string,
        "X-SGR-CorrelationID": correlationId,
      }),
      method: "GET",
    });
    try {
      if (apiResponse.status === 204) {
        response.data = undefined;
        response.serverError = false;
        return response;
      }
      if (!apiResponse.ok) {
        return handleNotOk(apiResponse);
      }
      response.data =
        fileName === null
          ? await apiResponse.json()
          : await handleBlob(apiResponse, fileName);
      return response;
    } catch (error) {
      response.serverError = true;
      return response;
    }
  });
}
function handleNotOk(apiResponse: Response) {
  const response = new GenericResponse();
  if (apiResponse.status === 403 && apiResponse.statusText === "Forbidden") {
    response.noAccessRights = true;
    return response;
  }
  if (apiResponse.status === 401 && apiResponse.statusText === "Unauthorized") {
    response.noAccessRights = true;
    return response;
  }
  if (
    apiResponse.status === 404 ||
    apiResponse.status === 500 ||
    apiResponse.status === 400
  ) {
    response.serverError = true;
    return response;
  }
  return response;
}
const getSgConnectTokenFromBus = (bus: IBus) =>
  new Promise<string | null>(resolve => {
    return bus
      ? resolve(
          bus.dangerouslyGetCurrentValue<string>("sg-connect.access-token")
        )
      : resolve(null);
  });
